var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.publicToken !== null && _vm.getContactForm === true
    ? _c(
        "div",
        { staticClass: "rp-cart-form" },
        [
          _c("v-style", [
            _vm._v(
              "\n    .rp-cart-form .vue-consent-container a {\n      color: " +
                _vm._s(_vm.color.link) +
                " !important;\n    }\n  "
            )
          ]),
          _vm._v(" "),
          _vm.contactForm.fields.length > 0
            ? _c(
                "div",
                [
                  _vm._l(_vm.contactForm.fields, function(item) {
                    return _c("div", { key: item.id }, [
                      _c("div", { staticClass: "form-label" }, [
                        item.label === "Firstname"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.t.labelFirstname) +
                                  "\n        "
                              )
                            ])
                          : item.label === "Lastname"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.t.labelLastname) +
                                  "\n        "
                              )
                            ])
                          : item.label === "Email"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.t.labelEmail) +
                                  "\n        "
                              )
                            ])
                          : item.label === "Tel."
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.t.labelTel) +
                                  "\n        "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(item.label) +
                                  "\n        "
                              )
                            ]),
                        _vm._v(" "),
                        item.required === "1"
                          ? _c("span", { staticClass: "rp-required-symbol" }, [
                              _vm._v("\n          *\n        ")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      item.type === "text" ||
                      item.type === "email" ||
                      item.type === "tel"
                        ? _c(
                            "div",
                            { staticClass: "form-input" },
                            [
                              _c("text-input", {
                                ref: "formInput" + item.id,
                                refInFor: true,
                                attrs: { inputData: item },
                                model: {
                                  value: _vm.fieldValues[item.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.fieldValues, item.id, $$v)
                                  },
                                  expression: "fieldValues[item.id]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "dropdown"
                        ? _c(
                            "div",
                            { staticClass: "form-input" },
                            [
                              _c("dropdown-input", {
                                ref: "formInput" + item.id,
                                refInFor: true,
                                attrs: { inputData: item },
                                model: {
                                  value: _vm.fieldValues[item.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.fieldValues, item.id, $$v)
                                  },
                                  expression: "fieldValues[item.id]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "radio"
                        ? _c(
                            "div",
                            { staticClass: "form-input" },
                            [
                              _c("radio-input", {
                                ref: "formInput" + item.id,
                                refInFor: true,
                                attrs: { inputData: item },
                                model: {
                                  value: _vm.fieldValues[item.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.fieldValues, item.id, $$v)
                                  },
                                  expression: "fieldValues[item.id]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "checkbox"
                        ? _c(
                            "div",
                            { staticClass: "form-input" },
                            [
                              _c("checkbox-input", {
                                ref: "formInput" + item.id,
                                refInFor: true,
                                attrs: { inputData: item },
                                model: {
                                  value: _vm.fieldValues[item.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.fieldValues, item.id, $$v)
                                  },
                                  expression: "fieldValues[item.id]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "textarea"
                        ? _c(
                            "div",
                            { staticClass: "form-input" },
                            [
                              _c("textarea-input", {
                                ref: "formInput" + item.id,
                                refInFor: true,
                                attrs: { inputData: item },
                                model: {
                                  value: _vm.fieldValues[item.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.fieldValues, item.id, $$v)
                                  },
                                  expression: "fieldValues[item.id]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "attachment"
                        ? _c(
                            "div",
                            { staticClass: "form-input" },
                            [
                              _c("file-input", {
                                ref: "formInput" + item.id,
                                refInFor: true,
                                attrs: {
                                  inputData: item,
                                  formData:
                                    _vm.contactForm.form
                                      .contact_attachment_allowed_file
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "datetime" || item.type === "date"
                        ? _c(
                            "div",
                            { staticClass: "form-input" },
                            [
                              _c("datetime-input", {
                                ref: "formInput" + item.id,
                                refInFor: true,
                                attrs: { inputData: item },
                                model: {
                                  value: _vm.fieldValues[item.id],
                                  callback: function($$v) {
                                    _vm.$set(_vm.fieldValues, item.id, $$v)
                                  },
                                  expression: "fieldValues[item.id]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br")
                    ])
                  }),
                  _vm._v(" "),
                  _vm.system === "ShopShappy"
                    ? _c("div", {
                        staticClass:
                          "cart-form vue-consent-container shappy-consent",
                        attrs: { id: "vue-consent-container" },
                        domProps: { innerHTML: _vm._s(_vm.consent.value) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hideContactButton !== 1
                    ? _c("div", { staticClass: "form-submit-button" }, [
                        _vm.formValidation.result === false
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "rp-validation-failed-message rp-buttons is-center"
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm.t.pleaseFillContactFormCompletely
                                    ) +
                                    "\n      "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "rp-buttons is-center" }, [
                          _vm.loading.submitButton === true
                            ? _c("div", { staticClass: "rp-icon" }, [
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-spin fa-2x"
                                })
                              ])
                            : _c(
                                "a",
                                {
                                  staticClass: "rp-button",
                                  style: {
                                    backgroundColor: _vm.color.secondaryMain,
                                    color: _vm.color.secondarySub,
                                    borderColor: _vm.color.secondaryMain,
                                    fontFamily: _vm.globalFont
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.submitContactForm()
                                    }
                                  }
                                },
                                [
                                  _vm.contactForm.form.contact_button_icon !==
                                    "" &&
                                  _vm.contactForm.form.contact_button_icon !==
                                    null
                                    ? [
                                        _c("span", { staticClass: "rp-icon" }, [
                                          _c("i", {
                                            class:
                                              "fa " +
                                              _vm.contactForm.form
                                                .contact_button_icon
                                          })
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.contactForm.form.contact_button_id ===
                                  "-1"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.contactForm.form
                                                .contact_button_custom_text
                                            ) +
                                            "\n          "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm.locale == "en"
                                          ? _c("span", [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.contactForm.form
                                                      .contact_button_text_en
                                                  ) +
                                                  "\n            "
                                              )
                                            ])
                                          : _vm.locale == "vi"
                                          ? _c("span", [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.contactForm.form
                                                      .contact_button_text_vi
                                                  ) +
                                                  "\n            "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.contactForm.form
                                                      .contact_button_text_th
                                                  ) +
                                                  "\n            "
                                              )
                                            ])
                                      ])
                                ],
                                2
                              )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cart-form vue-consent-container",
                          attrs: { id: "vue-consent-container" },
                          domProps: { innerHTML: _vm._s(_vm.consent.value) }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "rp-modal rp-remove-modal",
                      class: { "is-active": _vm.modals.thankyou }
                    },
                    [
                      _c("div", {
                        staticClass: "rp-modal-background",
                        on: {
                          click: function($event) {
                            return _vm.closeModal("thankyou")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "rp-modal-content rp-box" }, [
                        _c(
                          "div",
                          { staticClass: "is-fluid thankyou-modal-container" },
                          [
                            _c("div", [
                              _vm.formSubmit.result === true
                                ? _c("span", { staticClass: "rp-icon" }, [
                                    _c("i", {
                                      staticClass: "fa fa-check-circle fa-4x"
                                    })
                                  ])
                                : _c("span", { staticClass: "rp-icon" }, [
                                    _c("i", {
                                      staticClass: "fa fa-times-circle fa-4x"
                                    })
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _vm.formSubmit.result === true
                              ? _c(
                                  "div",
                                  { staticClass: "thankyou-modal-text" },
                                  [_vm._v(_vm._s(_vm.t.formSubmitThankyou))]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "thankyou-modal-text" },
                                  [_vm._v(_vm._s(_vm.t.formSubmitError))]
                                )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("button", {
                        staticClass: "rp-modal-close is-large",
                        attrs: { "aria-label": "close" },
                        on: {
                          click: function($event) {
                            return _vm.closeModal("thankyou")
                          }
                        }
                      })
                    ]
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("policy-popup")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65ad3d97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ad3d97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cartForm/index.vue
// module id = null
// module chunks = 